import {
  BookingChannels,
  ScheduleRequestReviewStatus,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AxisGroup } from '@frontend/charts';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';

// These keys are based on api response
export const weaveStatusColors: Record<string, string> = {
  'In Office': theme.colors.primary50,
  'No Show': theme.colors.critical50,
  Attempted: theme.colors.secondary.eggplant60,
  Canceled: theme.colors.critical30,
  Completed: theme.colors.secondary.seaweed40,
  Confirmed: theme.colors.success30,
  Unconfirmed: theme.colors.primary20,
  Unknown: theme.colors.warning20,
};

// These keys are based on api response
export const weaveStatusLabels: Record<string, string> = {
  'In Office': i18next.t('In Office', { ns: 'analytics' }),
  'No Show': i18next.t('No Show', { ns: 'analytics' }),
  Attempted: i18next.t('Attempted', { ns: 'analytics' }),
  Canceled: i18next.t('Canceled', { ns: 'analytics' }),
  Completed: i18next.t('Completed', { ns: 'analytics' }),
  Confirmed: i18next.t('Confirmed', { ns: 'analytics' }),
  unconfirmed: i18next.t('Unconfirmed', { ns: 'analytics' }),
  Unconfirmed: i18next.t('Unconfirmed', { ns: 'analytics' }),
  Unknown: i18next.t('Unknown', { ns: 'analytics' }),
};

export enum APPOINTMENT_TABS {
  UPCOMING = 'UPCOMING',
  PAST = 'PAST',
}

export enum VIEW_KEYS {
  CHART = 'CHART',
  TABLE = 'TABLE',
}

export const SCHEDULE_REQUEST_STATUS_LABELS: Partial<Record<ScheduleRequestReviewStatus, string>> = {
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_PENDING]: i18next.t('Pending', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_ACCEPTED]: i18next.t('Accepted', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_REJECTED]: i18next.t('Denied', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_MESSAGED]: i18next.t('Messaged', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_CALLED]: i18next.t('Called', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_DONE]: i18next.t('Done', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_DISMISSED]: i18next.t('Dismissed', { ns: 'analytics' }),
  [ScheduleRequestReviewStatus.SCHEDULE_REQUEST_REVIEW_STATUS_DELETED]: i18next.t('Deleted', { ns: 'analytics' }),
};

export const ScheduleRequestChannelLabels: Record<BookingChannels, string> = {
  [BookingChannels.BOOKING_CHANNEL_AIR]: i18next.t('AI Receptionist', { ns: 'analytics' }),
  [BookingChannels.BOOKING_CHANNEL_ONLINE]: i18next.t('Online', { ns: 'analytics' }),
  [BookingChannels.BOOKING_CHANNEL_OTHER]: i18next.t('Other', { ns: 'analytics' }),
};

export const scheduleRequestsYAxisGroups: AxisGroup[] = [
  {
    label: i18next.t('Channels', { ns: 'analytics' }),
    key: 'channel',
    icon: 'updates',
    options: [
      {
        label: ScheduleRequestChannelLabels[BookingChannels.BOOKING_CHANNEL_AIR],
        value: BookingChannels.BOOKING_CHANNEL_AIR,
      },
      {
        label: ScheduleRequestChannelLabels[BookingChannels.BOOKING_CHANNEL_ONLINE],
        value: BookingChannels.BOOKING_CHANNEL_ONLINE,
      },
      {
        label: ScheduleRequestChannelLabels[BookingChannels.BOOKING_CHANNEL_OTHER],
        value: BookingChannels.BOOKING_CHANNEL_OTHER,
      },
    ],
  },
];
